import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import Select from '@mui/material/Select';
import MenuItem from '@mui/material/MenuItem';
import type { SelectProps } from '@mui/material/Select';

export interface SelectOption {
  value: string | number;
  label: string;
}

type FaimSelectInputProps = Omit<SelectProps, 'children'> & {
  options: SelectOption[];
  /** When false, the form control won't stretch to fill its container. Default: true */
  fullWidth?: boolean;
};

/**
 * Reusable select input — wraps MUI Select with consistent sizing and label.
 */
export function SelectInput({ options, label, fullWidth = true, sx, ...props }: FaimSelectInputProps) {
  // Slugify so multi-word labels produce a valid (space-free) id — an id with a
  // space breaks the Select's aria-labelledby association (it parses as two ids).
  const labelId = `select-label-${String(label ?? '').replace(/\s+/g, '-')}`;

  return (
    <FormControl size="small" fullWidth={fullWidth} sx={sx}>
      {label && <InputLabel id={labelId}>{label}</InputLabel>}
      <Select
        labelId={labelId}
        label={label}
        {...props}
      >
        {options.map((opt) => (
          <MenuItem key={opt.value} value={opt.value}>
            {opt.label}
          </MenuItem>
        ))}
      </Select>
    </FormControl>
  );
}
